import "./style.css";
import Game from "./components/Game";
import favicon from "./favicon.ico"

window.onload = () => {
    new Game()
}